function datePartsInTimeZone(value, timeZone) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  try {
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);
    const values = {};
    parts.forEach((part) => {
      if (part.type !== "literal") values[part.type] = part.value;
    });
    if (!values.year || !values.month || !values.day) return null;
    return values;
  } catch {
    return null;
  }
}

function parseDateOnly(value) {
  const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  return {
    year: match[1],
    month: match[2],
    day: match[3],
  };
}

function pad2(value) {
  return String(value).padStart(2, "0");
}

export function toIsoDate(value, timeZone) {
  if (typeof value === "string") {
    const dateOnly = parseDateOnly(value);
    if (dateOnly) {
      return `${dateOnly.year}-${dateOnly.month}-${dateOnly.day}`;
    }
  }
  const parts = datePartsInTimeZone(value, timeZone);
  if (!parts) return "";
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function currentMonthValue(timeZone) {
  const parts = datePartsInTimeZone(new Date(), timeZone);
  if (!parts) return "";
  return `${parts.year}-${parts.month}`;
}

export function monthRange(monthValue) {
  const [year, month] = String(monthValue || "").split("-").map(Number);
  if (!Number.isFinite(year) || !Number.isFinite(month)) {
    return { start_date: "", end_date: "", label: "" };
  }
  const end = new Date(Date.UTC(year, month, 0));
  const label = new Intl.DateTimeFormat("en-CA", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(year, month - 1, 1)));
  return {
    start_date: `${year}-${pad2(month)}-01`,
    end_date: `${year}-${pad2(month)}-${pad2(end.getUTCDate())}`,
    label,
  };
}

export function monthValueFromDate(value, timeZone) {
  if (!value) return "";
  if (typeof value === "string") {
    const dateOnly = parseDateOnly(value);
    if (dateOnly) return `${dateOnly.year}-${dateOnly.month}`;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const parts = datePartsInTimeZone(date, timeZone);
  if (!parts) return "";
  return `${parts.year}-${parts.month}`;
}

export function requestMatchesMonth(request, selectedMonth, timeZone) {
  if (!selectedMonth) return true;
  const values = [
    request?.period_start,
    request?.period_end,
    request?.due_date,
    request?.created_at_utc,
  ].map((value) => monthValueFromDate(value, timeZone));
  return values.includes(selectedMonth);
}

export function money(value) {
  const number = Number(value || 0);
  return number.toLocaleString("en-CA", {
    style: "currency",
    currency: "CAD",
  });
}
